import Env from "../common/env"

function WebTransfer(config) {
    this.config = config;
    this.method = 'GET'
    this.readyState = 0;
    this.status = 0;
    this.statusText = '';
    this.responseText = '';
    this.timeout = 0;
    this.headers = {};
    this.resHeaders = {};
}

WebTransfer.prototype.send = function (body) {
    let self = this;
    // 模拟state2-3
    self.readyState = 2;
    self.onreadystatechange?.();
    self.readyState = 3;
    self.onreadystatechange?.();

    if( Env.isAndroid ) {// android得使用对象
        try {
            body = JSON.parse(body)
        }catch(e) {}
    }
    // 透传页面的cookie，后台部分场景会依赖cookie
    if( typeof document !== 'undefined' && document.cookie ) {
        this.headers.cookie = document.cookie
    }
    WXGAME.WxBridge.invoke('webTransfer', {
        method: this.method.toUpperCase() === 'POST' ? 1 : 0,
        reqUrl: this.url,
        reqBody: body,
        scope: this.config.scope,
        header: this.headers,
        h5Url: this.config.h5_url || 'https://game.weixin.qq.com/cgi-bin/h5/static/contentcenter/home.html'
    }, (res) => {
        self.readyState = 4;
        if( res.errCode === 0 || res.err_msg?.indexOf(":ok") > -1) {
            self.status = 200;
            self.responseText = res.result || res.respJson;
            if( res.header ) {
                this.resHeaders = JSON.parse(res.header);
            }
            self.onreadystatechange?.();
        }else {
            self.status = res.errCode || 500;
            self.onreadystatechange?.();
        }
    })
}

WebTransfer.prototype.open = function(method, url, async) {
    this.method = method;
    this.url = url;
    this.async = async;
}


WebTransfer.prototype.setRequestHeader = function (key, value) {
    this.headers[key] = value
}

WebTransfer.prototype.abort = () => {}

WebTransfer.prototype.getResponseHeader =  function(key) {
    if( !key ) {
        return ''
    }
    return this.resHeaders[key]
}

/**
 *	@class
 *	生成一个xmlhttprequest 对象,兼容性考虑
 *	@public
 *	@param 	_aoWin	window对象
 *
 *	@return xmlhttprequest
 *	@example
 *
 *	var xhr = QMAjax.newXhr();
 *
 */
QMAjax.newXhr = function (_aoWin) {
    var _oWin = _aoWin || window;
    var fun = function () {};
    if (_oWin.ActiveXObject) {
        try {
            return new _oWin.ActiveXObject("MSXML2.XMLHTTP");
        } catch (_oError) {
            try {
                return new _oWin.ActiveXObject("Microsoft.XMLHTTP");
            } catch (_oError) {
                return {
                    send: fun,
                    open: fun,
                    setRequestHeader: fun,
                    abort: fun
                };
            }
        }
    }
    if (_oWin.XMLHttpRequest) {
        return new _oWin.XMLHttpRequest;
    } else {
        return {
            send: fun,
            open: fun,
            setRequestHeader: fun,
            abort: fun
        };
    }
};
/**
 *	@class
 *	用于发起ajax请求的类
 *	@public
 *	@param 	_asUrl	cgi地址
 *			_asMethod	请求方式, POST || GET
 *			_anTimeout	请求超时设置,如果不设置就是15秒
 *			_aoXmlObj	xmlhttprequest对象,如果不传,则会自己生成一个。
 *	@return xmlhttprequest
 *	@example
 *
 *	var data = {};
 *	var xhr = new QMAjax('http://test.com/r.cgi','POST',30000);
 *	xhr.onComplete = function(xmlhttprequest){
 *		alert(xmlhttprequest.responseText);
 *	};
 *	xhr.onError = function(xmlhttprequest,errorcode){
 *		alert(xmlhttprequest.responseText);
 *		alert(errorcode); //errorcode in {ok,abort,abortCustom,xmlhttprequest.status}
 *	};
 *	xhr.send(mapToStr(data));
 *
 */
function QMAjax(_asUrl, _asMethod, _anTimeout, _aoXmlObj) {
    var _oSelf = this,
        _oXmlObj = _aoXmlObj,
        _nTimer;

    function _onOk() {
        _oSelf.onComplete(_oXmlObj);
    }

    function _onErr(_asMode, statusCode) {
        _oSelf.onError(_oXmlObj, _asMode, statusCode);
    }

    function _makeTimer(_anNewTimeout) {
        if (!_nTimer) {
            _nTimer = setTimeout(
                function () {
                    _oSelf.abort();
                },
                _anNewTimeout
            );
        }
    }

    function _clearTimer(_asMode, statusCode) {
        if (_nTimer) {
            clearTimeout(_nTimer);
            _nTimer = null;
            if (_asMode != "ok") {
                _onErr(_asMode, statusCode);
            }
            return true;
        }
        return false;
    }

    // 遇到几次被QB(X5浏览器)误加了 @@@时间戳@@@ ，在这直接加&结尾，解决该问题 add by zijianyang 
    if(_asUrl){
        if(_asUrl.indexOf("?") !== -1){
            _asUrl += "&QB&";
        }else{
            _asUrl += "?&QB&";
        }
    }

    // interface
    this.method = _asMethod || "POST";
    this.url = _asUrl;
    this.async = true;
    this.content = "";
    this.timeout = _anTimeout;

    // report
    this.timeArr = [];
    this.status = 0;

    // event
    this.onComplete = function () {};
    this.onError = function () {};
    let webTransferConfig = WXGAME?.GlobalConfig?.webtransfer?.getWebTransferUrlConfig?.(_asUrl);

    if (!_oXmlObj) {
        if( webTransferConfig ) {
            _oXmlObj = new WebTransfer(webTransferConfig);
        }else {
            _oXmlObj = QMAjax.newXhr();
        }
    }

    if (!_oXmlObj) {
        return false;
    }

    _oXmlObj.webTransferConfig = webTransferConfig;

    // 附着上报属性
    _oXmlObj.timeArr = [];

    // state 0
    _oXmlObj.timeArr.push( Math.floor(new Date().getTime()) );

    this.headers = {};

    // action
    /**
     *
     */
    this.abort = function () {
        _clearTimer("abort");
        _oXmlObj.abort();
    };

    this.abortCustom = function () {
        _clearTimer("abortCustom");
        _oXmlObj.abort();
    };

    /**
     *
     * @param {String} _asPostContent
     * @return {Boolean}
     */
    this.send = function (_asPostContent, options) {
        options = options || {}

        if (!this.method || !this.url || !this.async) {
            return false;
        }
        typeof this.url == "object" && (this.url = this.url.replace({}));

        var _sMethod = this.method.toUpperCase();
        this.abort();

        _oXmlObj.open(_sMethod,
            this.url,
            this.async
        );
        // state 1
        _oXmlObj.timeArr.push( Math.floor(new Date().getTime()) );

        if (_sMethod == "POST") {
            //_oXmlObj.setRequestHeader("Content-Type", document.charset);
            //_oXmlObj.setRequestHeader("Content-length", this.content.length);
            if (options.contentType === 'multipart/form-data') {
                // form-data 不需要手动设 content-type
            } else if(isJson(_asPostContent)){
                _oXmlObj.setRequestHeader("Content-Type",
                    "application/json; charset=utf-8"
                );
            }else{
                _oXmlObj.setRequestHeader("Content-Type",
                    "application/x-www-form-urlencoded"
                );
            }
        }

        E(this.headers, function (_asValue, _asKey) {
            _oXmlObj.setRequestHeader(_asKey, _asValue);
        });
        
        let gameSessionId = Env.getGameSessionId();
        if( gameSessionId ) {
            _oXmlObj.setRequestHeader('x-wxgame-session', gameSessionId);
        }
        

        _oXmlObj.ontimeout = this.onTimeout || function () {
            // alert('服务器超时啦，请稍后再试');
        };
        _oXmlObj.timeout = this.timeout || 15000;

        _oXmlObj.onreadystatechange = function () {
            // state 2 - 4
            _oXmlObj.timeArr.push( Math.floor(new Date().getTime()) );

            if (_oXmlObj.readyState === 4) {                            
                if (_oXmlObj.status === 200) {
                    if (_clearTimer("ok", _oXmlObj.status)) {
                        _onOk();
                    }
                } else {
                    _clearTimer(
                        [
                            _oXmlObj.statusText,
                            _oXmlObj.status,
                            _oXmlObj.timeout
                        ].join('_'),
                        _oXmlObj.status
                    );
                }
            }
        };

        // ### warnning ###
        _makeTimer((this.timeout || 15000) + 1000);

        try {
            if (_sMethod == "POST") {
                var _sContent = ''
                if (options.contentType === 'multipart/form-data') {
                    _sContent = new FormData()
                    for (let key in _asPostContent) {
                        _sContent.append(key, _asPostContent[key])
                    }
                } else {
                    _sContent = [_asPostContent || this.content, ""].join("");
                }
                _oXmlObj.send(_sContent);
            } else {
                _oXmlObj.send(null);
            }
        } catch (_oError) {
            _clearTimer(_oError.message);
        }
        return true;
    }
}

function E(_avList, _afRunFunc, _anStart, _anEnd) {
    if (!_avList) {
        return;
    }

    if (_avList.length != null) {
        var _nLen = _avList.length,
            _nEnd;

        if (_anEnd < 0) {
            _nEnd = _nLen + _anEnd;
        } else {
            _nEnd = _anEnd < _nLen ? _anEnd : _nLen;
        }

        for (var i = (_anStart || 0); i < _nEnd; i++) {
            try {
                if (_afRunFunc(_avList[i], i, _nLen) === false) {
                    break;
                }
            } catch (_oError) {
                //debug([_oError.message, "<br>line:", _oError.lineNumber, '<br>file:', _oError.fileName, "<br>", _afRunFunc]);
            }
        }
    } else {
        for (var i in _avList) {
            try {
                if (_afRunFunc(_avList[i], i) === false) {
                    break;
                }
            } catch (_oError) {
                //debug([_oError.message, "<br>", _afRunFunc]);
            }
        }
    }
}
function isJson(_sContent){
    var _bIsJSON = false;
    try{
        var _isJson = JSON.parse(_sContent);
        _bIsJSON = !!_isJson;
    }catch(e){
        _bIsJSON = false;
    }
    return _bIsJSON;
}
export default QMAjax;

export const {
    newXhr
} = QMAjax;
